import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  InputLabel,
  PaziaFormButton,
  PaziaInput,
  PaziaSelect,
} from "components/atoms";
import { useSurveysOptions } from "api/hooks";
import { FaPlus, FaTrashAlt } from "react-icons/fa";

interface CourseSurveysFormProps {
  endSurvey?: number;
  onSubmit: (data: CourseSurveysFormValues) => Promise<void>;
}
export const CourseSurveysForm = ({ endSurvey, onSubmit }: CourseSurveysFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      [FORM_NAMES.END_SURVEY]: endSurvey?.toString() ?? "",
    },
  });

  const { handleSubmit } = methods;
  const { loading, options } = useSurveysOptions("isEndCourse eq 'true'");

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex gap-4 h-full">
        <PaziaSelect
          name={FORM_NAMES.END_SURVEY}
          label="Ankieta końcowa"
          className="w-full"
          options={options}
          required
          isLoading={loading}
        />
        <div className="mt-auto">
          <PaziaFormButton title="Zapisz" type="success" />
        </div>
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  END_SURVEY: "endSurvey",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.END_SURVEY]: yup.string().required(),
  })
  .required();
export type CourseSurveysFormValues = yup.InferType<typeof schema>;
